import { render, staticRenderFns } from "./service-worker-update-popup.vue?vue&type=template&id=68047b6e&scoped=true&"
import script from "./service-worker-update-popup.component.ts?vue&type=script&lang=ts&"
export * from "./service-worker-update-popup.component.ts?vue&type=script&lang=ts&"
import style0 from "./service-worker-update-popup.vue?vue&type=style&index=0&id=68047b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68047b6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68047b6e')) {
      api.createRecord('68047b6e', component.options)
    } else {
      api.reload('68047b6e', component.options)
    }
    module.hot.accept("./service-worker-update-popup.vue?vue&type=template&id=68047b6e&scoped=true&", function () {
      api.rerender('68047b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pwa/components/service-worker-update-popup.vue"
export default component.exports